<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">{{title}}</h1>
      </v-flex>
    </v-layout>

    <div v-if="monitoringList !== null ? monitoringList.length > 0 : false">
      <v-layout row class="mx-3">
        <v-flex xs12>
          <template>
            <v-data-table
                :headers="headers"
                :items="monitoringList"
                hide-actions
                class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">
                  <span class="cursor-pointer" @click="$router.push('/monitorings/single/' + props.item.id)">{{props.item.title}}</span>
                </td>
                <td class="text-xs-left">{{ $moment(props.item.start_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">{{ $moment(props.item.end_date).format('DD.MM.YYYY') }}</td>
                <td class="text-xs-left">{{ props.item.frequency }}</td>
                <td class="text-xs-left">{{ props.item.max_checks }}</td>
                <td class="text-xs-left">{{ props.item.is_required ? 'Да' : 'Нет' }}</td>
                <td class="text-xs-left">
                  <div v-if="mode === 'active'">
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="editMonitoring(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                        flat
                        icon
                        class="ma-1"
                        @click="deleteMonitoring(props.item.id)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </div>
                </td>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="mode === 'active' && monitoringList !== null ? monitoringList.length === 0 : false">
      <div class="ml-3 subheading">Нет активных мониторингов. <span @click="$router.push('/monitorings/new')" class="cursor-pointer primary--text">Добавить новый</span></div>
    </div>

    <div v-if="mode === 'archive' && monitoringList !== null ? monitoringList.length === 0 : false">
      <div class="ml-3 subheading">Нет архивных мониторингов.</div>
    </div>

    <v-layout row v-if="pages > 1">
      <v-flex xs12>
        <div class="text-xs-left mt-3">
          <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="7"
              @input="changePage()"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog
        v-model="deleteDialog"
        max-width="300"
        v-if="mode === 'active'"
    >
      <v-card>
        <v-card-title class="headline">Удалить мониторинг?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              @click="deleteMonitoringConfirm(deleteMonitoringId)"
          >
            Удалить
          </v-btn>

          <v-btn
              @click="deleteMonitoringCancel()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
  import HelpMixin from '../../mixins/help'

  export default {
    mixins: [HelpMixin],
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Мониторинг'}
        ],
        headers: [
          {
            text: 'Название',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата начала действия',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Дата окончания',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Не чаще чем раз в N дней',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Максимальное кол-во посещений',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Обязательно',
            align: 'left',
            sortable: false,
            value: 'name'
          },
          {
            text: 'Действия',
            align: 'left',
            sortable: false,
            value: 'name'
          }
        ],
        pageDataReady: {
          isReady: false,
          monitoringList: false
        },
        page: 1,
        mode: 'active',
        title: 'Активные мониторинги',
        deleteDialog: false,
        deleteMonitoringId: null
      }
    },
    methods: {
      indicatorFormatting (val) {
        val = Math.round(parseFloat(val)).toString()
        let result = ''
        let i = 0
        val.split('').reverse().forEach(function (char) {
          if (i === 3) {
            result += ' '
            i = 1
          } else {
            i++
          }
          result += char
        })
        result = result.split('').reverse().join('')
        return result
      },
      pageDataStatus () {
        if (!this.pageDataReady.monitoringList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      changePage () {
        this.scrollUp()

        this.pageDataReady = {
          isReady: false,
          monitoringList: false
        }
        this.$store.commit('setPageLoading', true)

        if (this.mode === 'active') {
          this.$router.push('/monitorings/active/' + this.page)
        } else if (this.mode === 'archive') {
          this.$router.push('/monitorings/past/' + this.page)
        } else {
          this.$store.dispatch('getMonitoringList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
        }
      },
      editMonitoring (id) {
        this.$router.push('/monitorings/edit/' + id)
      },
      deleteMonitoring (id) {
        this.deleteDialog = true
        this.deleteMonitoringId = id
      },
      deleteMonitoringCancel () {
        this.deleteDialog = false
        this.deleteMonitoringId = null
      },
      async deleteMonitoringConfirm () {
        this.deleteDialog = false
        await this.$store.dispatch('deleteMonitoring', {id: this.deleteMonitoringId})
        this.deleteMonitoringId = null
        await this.$store.dispatch('getMonitoringList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
      },
      onCreated () {
        if (typeof this.$route.params.page !== 'undefined') {
          this.page = parseInt(this.$route.params.page)
        } else {
          this.page = 1
        }
        if (~this.$router.currentRoute.path.indexOf('/monitorings/active')) {
          this.mode = 'active'
          this.title = 'Активные мониторинги'
        } else if (~this.$router.currentRoute.path.indexOf('/monitorings/past')) {
          this.mode = 'archive'
          this.title = 'Архив мониторингов'
        }
        this.$store.commit('setPageLoading', true)
        this.$store.commit('setPageTitle', this.title)

        this.$store.dispatch('getMonitoringList', {mode: this.mode, offset: (this.page - 1) * 10, limit: 10})
          .then(() => {
            this.pageDataReady.monitoringList = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      monitoringList () {
        return this.$store.getters.monitoringList
      },
      totalCount () {
        return this.$store.getters.monitoringTotalCount
      },
      pages () {
        let pages = this.totalCount / 10
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Monitorings/MonitoringList.vue